export default __webpack_public_path__ + "static/gbca-83de3dd561908d478c9c62fa0f08d4c2.png";